<template>
  <b-sidebar :id="local_user.id ? 'sidebar-edit-' + local_user.id : 'sidebar-new'" :title="local_user.id ? 'Editar usuario' : 'Nuevo usuario'" sidebar-class="bb-offcanvas-panel"
             bg-variant="white" right backdrop-variant="dark" backdrop shadow>
    <template #default="{ hide }">
      <div class="row form-row" :class="{ 'form-group--error': $v.local_user.givenName.$error }">
        <label class="column col-sm-12 ng-scope form__label" :for="'user-name-' + local_user.id"><span class="mandatory-mark" aria-hidden="true">*</span> Nombre del usuario</label>
        <input type="text" :id="'user-name-' + local_user.id" v-model="local_user.givenName"
               maxlength="255" placeholder="Nombre">
      </div>
      <div class="row form-row" :class="{ 'form-group--error': $v.local_user.lastName.$error }">
        <label class="column col-sm-12 ng-scope form__label" :for="'user-lastname-' + local_user.id"><span class="mandatory-mark" aria-hidden="true">*</span>Apellidos del usuario</label>
        <input type="text" :id="'user-lastname-' + local_user.id" v-model="local_user.lastName"
               maxlength="255" placeholder="Apellidos">
      </div>
      <div v-if="!local_user.id" class="row form-row" :class="{ 'form-group--error': $v.local_user.contactEmail.$error }">
        <label class="column col-sm-12 ng-scope form__label" :for="'user-contactEmail-' + local_user.id"><span class="mandatory-mark" aria-hidden="true">*</span>Correo electrónico</label>
        <input type="text" :id="'user-contactEmail-' + local_user.id" v-model="local_user.contactEmail"
               maxlength="255" placeholder="Correo electrónico">
      </div>
      <div v-if="!local_user.id" class="row form-row" :class="{ 'form-group--error': $v.local_user.unirType.$error }">
        <label class="column col-sm-12 ng-scope form__label" :for="'user-unirType-' + local_user.id"><span class="mandatory-mark" aria-hidden="true">*</span>Tipo</label>
        <b-form-select :id="'user-unirType-' + local_user.id" :options="user_type_options" v-model="local_user.unirType" disabled></b-form-select>
      </div>
      <div v-if="!local_user.id" class="row form-row" :class="{ 'form-group--error': $v.local_user.unirId.$error }">
        <label class="column col-sm-12 ng-scope form__label" :for="'user-unirId-' + local_user.id"><span class="mandatory-mark" aria-hidden="true">*</span>ID Proeduca</label>
        <input type="text" :id="'user-unirId-' + local_user.id" v-model="local_user.unirId"
               maxlength="255" placeholder="ID Proeduca">
      </div>
      <fieldset v-if="!local_user.id || (isStaff(local_user) && !local_user.zoomId)">
        <legend>
          <h3 class="form-label">Crear licencia en Zoom para el usuario
          </h3>
        </legend>
        <div class="checkbox-wrap list">
          <input :id="'user-createZoomAccount-' + local_user.id" type="checkbox" v-model="local_user.createZoomAccount">
          <label :for="'user-createZoomAccount-' + local_user.id" style="padding-top: .5%;">Crear licencia en Zoom para el usuario</label>
        </div>
      </fieldset>
      <div v-if="local_user.id && isStaff(local_user)" class="row form-row">
        <label :for="'user-zoomid-' + local_user.id">Identificador en Zoom</label>
        <input type="text" :id="'user-zoomid-' + local_user.id" v-model="local_user.zoomId"
               maxlength="255" placeholder="Identificador en Zoom">
      </div>
    </template>
    <template #footer="{ hide }">
      <div class="save-buttons panel-footer">
        <div class="buttons-2 equal-buttons row">
          <div class="col-sm-6">
            <button class="button secondary cancel-button" @click="hide">Cancelar</button>
          </div>
          <div class="col-sm-6">
            <button class="button save-button" @click="updateUser">Guardar</button>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import LocationEnterIcon from 'vue-material-design-icons/LocationEnter.vue'
import utilitiesMixin from '../../../mixins/utilitiesMixin'
import {required, requiredIf} from 'vuelidate/lib/validators'

export default {
  name: 'EditUserSidebar',
  components: {CloseIcon, LocationEnterIcon},
  mixins: [utilitiesMixin],
  props: ['user'],
  mounted () {
    this.$moment.locale('es')
  },
  data () {
    return {
      loading: false,
      local_user: this._.cloneDeep(this.user),
      user_type_options: this.unirTypeOptions()
    }
  },
  validations: {
    local_user: {
      givenName: {
        required
      },
      lastName: {
        required
      },
      contactEmail: {
        required: requiredIf(function () {
          return !this.local_user.id
        })
      },
      unirType: {
        required: requiredIf(function () {
          return !this.local_user.id
        })
      },
      unirId: {
        required: requiredIf(function () {
          return !this.local_user.id
        })
      }
    }
  },
  methods: {
    updateUser () {
      let vueComponent = this

      // CMM: Validación previa al envío de formulario
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.local_user.fullName = this.local_user.givenName + ' ' + this.local_user.lastName
      this.local_user.createZoomAccount = this.local_user.zoomId ? false : this.local_user.createZoomAccount
      // CMM: Se distingue un alta de una actualización
      if (this.local_user.id) {
        window.axios.put('users/' + this.local_user.id, this.local_user).then((response) => {
          if (response && response.status === 200) {
            vueComponent.$noty.success('La información del usuario se ha actualizado correctamente', {
              timeout: 3000,
              progressBar: true
            })
            vueComponent.$root.$emit('bv::toggle::collapse', 'sidebar-edit-' + vueComponent.local_user.id)
            vueComponent.$emit('refresh')
            vueComponent.hide()
          } else {
            vueComponent.$noty.error('No se ha podido actualizar el usuario. Compruebe los datos de configuración.', {
              timeout: 3000,
              progressBar: true
            })
          }
        })
      } else {
        window.axios.post('users/', this.local_user).then((response) => {
          if (response && response.status === 200) {
            vueComponent.$noty.success('El usuario se ha registrado correctamente', {
              timeout: 3000,
              progressBar: true
            })
            vueComponent.$root.$emit('bv::toggle::collapse', 'sidebar-new')
            vueComponent.$emit('refresh')
            vueComponent.hide()
          } else {
            vueComponent.$noty.error('No se ha podido registrar el usuario. Compruebe los datos de configuración.', {
              timeout: 3000,
              progressBar: true
            })
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Modals/EditUserSidebar.vue